import { createContext } from "react";
import Keycloak from "keycloak-js";

type AuthUser = {
  id: string;
  name: string;
  family_name: string;
  given_name: string;
  email: string;
};

type AuthContextType = {
  keycloak: Keycloak;
  authenticated: boolean;
  initialized: boolean;
  authUser: AuthUser | null;
  permissions: string[];
  hasPermission?: (permission: string) => boolean;
  appConfig?: {
    logo?: string;
    institution_name?: string;
  } | null;
  configLoaded?: boolean;
  getUserRoleType: () => "admin" | "editor" | "reader" | "empty";
  featureFlags?: Record<string, boolean>;
};

export const AuthContext = createContext<AuthContextType | undefined>(
  undefined,
);
